import React from 'react';


export type Permission = string;

type PermissionContextType = {
    isAllowedTo: (permission: Permission) => Promise<boolean>;
}
const defaultBehaviour: PermissionContextType = {
    isAllowedTo: () => Promise.resolve(false)
}

// Create the context
const PermissionContext = React.createContext<PermissionContextType>( defaultBehaviour);

export default PermissionContext;